module.exports = __webpack_public_path__ + "static/media/linkedin.04779755.svg";